import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';

import { StoreContainerModel } from '../../../../../models/aggregates/store/store-container.model';
import { ApiVisa, Pagination } from '../shared';

// https://api.akaun.dev/core2/platform/dm/stores/

@Injectable({
  providedIn: 'root'
})
export class StoreService extends BaseApiTemplateService<StoreContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'stores';
    this.httpClient = http;
  }

  private setUrl(endpoint: string) {
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + `stores/${endpoint}`;
  }

  sysadminPost(dtoObject: StoreContainerModel, apiVisa: ApiVisa) {
    this.setUrl('sysadmin-ep');
    return super.post(dtoObject, apiVisa);
  }

  sysadminPut(dtoObject: StoreContainerModel, apiVisa: ApiVisa) {
    this.setUrl('sysadmin-ep');
    return super.put(dtoObject, apiVisa);
  }

  sysadminInactivate(guid: string, apiVisa: ApiVisa) {
    this.setUrl(`inactivation/sysadmin-ep/${guid}?status=DELETED`);
    return super.put(null, apiVisa);
  }

  sysadminGet(apiVisa: ApiVisa) {
    this.setUrl('sysadmin-ep');
    return super.get(apiVisa);
  }

  sysadminGetByCriteria(pagination: Pagination, apiVisa: ApiVisa) {
    this.setUrl('sysadmin-ep');
    return super.getByCriteria(pagination, apiVisa);
  }

  tenantAdminGetByGuid(tenantCode: string, guid: string, apiVisa: ApiVisa) {
    const postUrl = 'tenant-admin-ep/' + tenantCode;
    this.setUrl(postUrl);
    return super.getByGuid(guid, apiVisa);
  }

  tenantAdminGetByCriteria(pagination: Pagination, tenantCode, apiVisa: ApiVisa) {
    const postUrl = 'tenant-admin-ep/' + tenantCode;
    this.setUrl(postUrl);
    return super.getByCriteria(pagination, apiVisa);
  }
}
